import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../../Components/HomeComponents/Navbar/Navbar";
import Footer from "../../../Components/HomeComponents/Footer/Footer";
import Context from "../../../Context/Context";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";
import {
  authRequest,
  authRequestNb,
  fixedNumber,
  refreshToken,removeExtraZeros
} from "../../../Helper/helper";
import styles from "./Partnership.module.scss";

const Partnership = () => {
  const { states } = useContext(Context);

  const [loading, setLoading] = useState(true);
  const [submitBtn, setSubmitBtn] = useState(false);
  const [settings, setSettings] = useState([]);
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [partners, setPartners] = useState([]);
  const [investmentLogs, setInvestmentLogs] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [amount, setAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState({});

  const planName = (type) => {
    if (type === "LIFETIME") return "Lifetime Partnership";
    if (type === "FIVE_YEAR") return "5 Year Partnership";
    return type;
  };

  const planDescription = (type) => {
    if (type === "LIFETIME") {
      return "In the Lifetime Partnership, you will receive lifetime earnings equal to 0.002% of admin trading fee for every 1000 USDT invested";
    }

    if (type === "FIVE_YEAR") {
      return "In the 5-Year Partnership, you will receive earnings equal to 0.04% of admin trading fee for every 1000 USDT invested. This plan will remain valid for 5 years.";
    }

    return "";
  };

  const autoData = async () => {
    setLoading(true);

    const res = await authRequestNb("partnership-details");

    if (res?.refresh_token) {
      refreshToken(res.refresh_token);
    }

    if (res?.status === 200) {
      setSettings(res?.data?.settings || []);
      setUsdtBalance(res?.data?.usdt_balance || 0);
      setPartners(res?.data?.partners || []);
      setInvestmentLogs(res?.data?.investment_logs || []);

      if (!selectedPlan && res?.data?.settings?.length > 0) {
        setSelectedPlan(res.data.settings[0].partnership_type);
      }
    } else {
      swal(res?.message || "Something went wrong");
    }

    setLoading(false);
  };

  useEffect(() => {
    autoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedSetting = settings.find(
    (item) => item.partnership_type === selectedPlan
  );

  const errorHandler = (key, value) => {
    setErrorMessage((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const submitPartnership = async () => {
    let hasError = false;

    if (!selectedPlan) {
      errorHandler("plan", "Please select partnership plan");
      hasError = true;
    }

    if (!amount || parseFloat(amount) <= 0) {
      errorHandler("amount", "Please enter valid amount");
      hasError = true;
    }

    if (selectedSetting) {
      if (parseFloat(amount) < parseFloat(selectedSetting.min_amount)) {
        errorHandler(
          "amount",
          `Minimum investment amount is ${selectedSetting.min_amount} USDT`
        );
        hasError = true;
      }

      if (parseFloat(amount) > parseFloat(selectedSetting.max_amount)) {
        errorHandler(
          "amount",
          `Maximum investment amount is ${selectedSetting.max_amount} USDT`
        );
        hasError = true;
      }
    }

    if (parseFloat(amount) > parseFloat(usdtBalance)) {
      errorHandler("amount", "Insufficient USDT balance");
      hasError = true;
    }

    if (hasError) return;

    const confirm = await swal({
      title: "Are you sure?",
      text: `You want to buy ${planName(selectedPlan)} with ${amount} USDT`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    });

    if (!confirm) return;

    setSubmitBtn(true);

    const res = await authRequest(
      {
        amount: amount,
        partnership_type: selectedPlan,
      },
    //   "buy-partnership"
      "partner/buy"
    );

    setSubmitBtn(false);

    if (res?.refresh_token) {
      refreshToken(res.refresh_token);
    }

    if (res?.status === 200) {
      await swal(res.message || "Partnership purchased successfully");
      setAmount("");
      await autoData();
    } else {
      swal(res?.message || "Something went wrong");
    }
  };

  return (
    <div className={`${styles.partnership_l} ligtMode`}>
      <Navbar />

      <div className={`${styles.hero} partnerHero`}>
        <div className="container">
          <div className={`${styles.heroInner} `}>
            <div>
              <h1>Partnership Plans</h1>
              <p>
                Become a platform partner and earn a share from admin trading fee
                based on your selected partnership plan.
              </p>
            </div>

            <div   className={`${styles.balanceBox} balanceBox`}>
              <span>Available USDT Balance</span>
                <h2>{removeExtraZeros(usdtBalance)} USDT</h2>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.container} container Partnership_container2`}  style={{marginTop:"10px"}}>
        {loading ? (
          <div className={styles.loader}>
            <i className="fa fa-spinner fa-spin"></i> Loading...
          </div>
        ) : (
          <>
            <div className={styles.planGrid}>
              {settings.map((plan) => (
                <div
                  key={plan.id}
                  className={`${styles.planCard} Partnership_Card ${
                    selectedPlan === plan.partnership_type ? styles.active : ""
                  }`}
                  onClick={() => {
                    setSelectedPlan(plan.partnership_type);
                    errorHandler("plan", "");
                  }}
                >
                  <div className={styles.planHeader}>
                    <h3>{planName(plan.partnership_type)}</h3>
                    <input
                      type="radio"
                      checked={selectedPlan === plan.partnership_type}
                      onChange={() => setSelectedPlan(plan.partnership_type)}
                    />
                  </div>

                  <p>{planDescription(plan.partnership_type)}</p>

                  <div className={`${styles.planInfo} planInfo ${
                    selectedPlan === plan.partnership_type ? styles.active : ""
                  }`}>
                    <div>
                      <span>Min Investment</span>
                      <strong>{removeExtraZeros(plan.min_amount)} USDT</strong>
                    </div>

                    <div>
                      <span>Max Investment</span>
                      <strong>{removeExtraZeros(plan.max_amount)} USDT</strong>
                    </div>

                    <div>
                      <span>Commission Per 1000 USDT</span>
                      <strong>{removeExtraZeros(plan.commission_per_1000)}%</strong>
                    </div>

                    <div>
                      <span>Validity</span>
                      <strong>
                        {plan.partnership_type === "LIFETIME"
                          ? "Lifetime"
                          : `${plan.validity_years || 5} Years`}
                      </strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {errorMessage.plan && (
              <p className={styles.warning_note}>{errorMessage.plan}</p>
            )}

            <div className={`${styles.buyBox} Partnership_Card`}>
              <h2>Buy Partnership</h2>

              <div className={styles.buyForm}>
                <div className={styles.inputBox}>
                  <label>Selected Plan</label>
                  <input value={planName(selectedPlan)} readOnly />
                </div>

                <div className={styles.inputBox}>
                  <label>Investment Amount USDT</label>
                  
                    <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={amount}
                    placeholder="Enter amount"
                    onPaste={(e) => {
                        const pastedValue = e.clipboardData.getData("text");

                        if (!/^\d+$/.test(pastedValue)) {
                        e.preventDefault();
                        }
                    }}
                    onKeyDown={(e) => {
                        const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                        ];

                        if (allowedKeys.includes(e.key)) {
                        return;
                        }

                        if (!/^[0-9]$/.test(e.key)) {
                        e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const value = e.target.value;

                        if (value === "") {
                        setAmount("");
                        errorHandler("amount", "");
                        return;
                        }

                        if (/^\d+$/.test(value)) {
                        setAmount(value);
                        errorHandler("amount", "");
                        }
                    }}
                    />
                  {/* {errorMessage.amount && (
                    <p className={styles.warning_note}>
                      {errorMessage.amount}
                    </p>
                  )} */}
                </div>

                <button
                  type="button"
                  onClick={submitPartnership}
                  disabled={submitBtn}
                  className={styles.buyBtn}
                >
                  {submitBtn ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "Buy Partnership"
                  )}
                </button>
              </div>
              <div className={styles.buyForm}>
                <div className={styles.inputBox}>
                </div>
                <div className={styles.inputBox}>
                  {errorMessage.amount && (
                    <p className={styles.warning_note}>
                      {errorMessage.amount}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div  className={`${styles.sectionBox} Partnership_Card`}>
              <h2>My Partnerships</h2>

              <div className="tableDesign custableresponsive table-responsive custableresponsive_height mt-15 heightAutoTable">
                <Table responsive>
                  <thead className="headStyle">
                    <tr>
                      <th>#</th>
                      <th>Plan</th>
                      <th>Investment</th>
                      <th>Currency</th>
                      <th>Commission %</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {partners.length > 0 ? (
                      partners.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>{planName(row.partnership_type)}</td>
                          <td>{removeExtraZeros(row.investment_amount)}</td>
                          <td>{row.currency_symbol}</td>
                          <td>{removeExtraZeros(row.commission)}</td>
                          <td>{row.start_date || "-"}</td>
                          <td>
                            {row.partnership_type === "LIFETIME"
                              ? "Lifetime"
                              : row.end_date || "-"}
                          </td>
                          <td>{row.status === "1" || row.status === 1 ? "Active" : "Inactive"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No partnership found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>

            <div  className={`${styles.sectionBox} Partnership_Card`}>
              <h2>Investment Logs</h2>

              <div className="tableDesign custableresponsive table-responsive custableresponsive_height mt-15 heightAutoTable">
                <Table responsive>
                  <thead className="headStyle">
                    <tr>
                      <th>#</th>
                      <th>Plan</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Commission %</th>
                      <th>Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {investmentLogs.length > 0 ? (
                      investmentLogs.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>{planName(row.partnership_type)}</td>
                          <td>{removeExtraZeros(row.amount)}</td>
                          <td>{row.currency_symbol}</td>
                          <td>{removeExtraZeros(row.commission_percent)}</td>
                          <td>{row.type}</td>
                          <td>{row.start_date || "-"}</td>
                          <td>
                            {row.partnership_type === "LIFETIME"
                              ? "Lifetime"
                              : row.end_date || "-"}
                          </td>
                          <td>{row.created_at || "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No investment log found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Partnership;